<template>
  <v-layout row wrap>
    <v-flex xs6>
      <v-text-field
        :value="number"
        @input="value => updateNumber(value)"
        type="number"
        :label="config.label"
        :name="config.key"
        :required="config.required"
        :id="config.key"
        :error="haveErrors()"
        :rules="config.errors"
        min="0"
        step="1">
      </v-text-field>
    </v-flex>
    <v-flex xs6>
      <v-select
        :value="range"
        @input="value => updateRange(value)"
        :items="ranges"
        item-text="name"
        item-value="code"
        dark>
      </v-select>
    </v-flex>
  </v-layout>
</template>

<script>
  import input from '@/mixins/input'
  export default {
    mixins: [input],
    data () {
      return {
        number: (this.value || '').split('.')[0],
        range: (this.value || '').split('.')[1] || 'days'
      }
    },
    computed: {
      ranges () {
        return [
          'hours',
          'days',
          'weeks'
        ]
          .map(e => ({ code: e, name: this.$t(`inputs.delay.ranges.${e}`) }))
      },
      finalValue () {
        return [
          this.number,
          this.range
        ].join('.')
      }
    },
    methods: {
      updateNumber (value) {
        this.number = value
        this.emit(this.finalValue)
      },
      updateRange (value) {
        this.range = value
        this.emit(this.finalValue)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/Delay.vue